import {createContext} from "react";
const ThemeContext:React.Context<string>=createContext('light');
export default ThemeContext;
export { ThemeContext }
